import React from 'react';
import FormikSearchDropdown from 'src/components/formik/FormikSearchDropdown/FormikSearchDropdown';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import PropTypes from 'prop-types';
import { commissionSearchAPI } from 'src/api/CommissionApi';

const CommissionDropDown = ({ value, name, ...rest }) => (
    <FormikSearchDropdown
        name={name}
        placeholder="Select Commission"
        displayKeyPath={[
            'commissionName',
        ]}
        valueKeyPath="_id"
        defaultValueFetchByKeyPath="_id"
        whereClauseKeysPaths={[
            'commissionName',
        ]}
        api={commissionSearchAPI}
        apiCallAddonData={{
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
        }}
        value={value}
        {...rest}
    />
);

CommissionDropDown.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
};

CommissionDropDown.defaultProps = { value: '' };

export default CommissionDropDown;
